// removed by extract-text-webpack-plugin
module.exports = {"YoutubePlayer":"YoutubePlayer__YoutubePlayer___11few","YoutubePlayerIframe":"YoutubePlayer__YoutubePlayerIframe___1_pDN"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/YoutubePlayer/YoutubePlayer.less
// module id = 1479
// module chunks = 0 1